import {
  userLogin,
  confirmEmail,
  verificationCode,
  userPassword,
  userMainLogin,
  userResendOtp,
} from "../requests/auth";
import { setCurrentClient } from "../../ducks/organization";
import { call, put } from "redux-saga/effects";
import {
  setUserLogin,
  setLoaderState,
  setConfirmEmail,
  setVerificationCode,
  setUserPassword,
  setUserRole,
  setUserAuthentication,
  setSentOtpSuccessFul,
  setOtpExpired,
} from "../../ducks/auth";

import { setTnCAccepted } from "../../ducks/user";

import { showToastMessage } from "../../../utils/toastMsg";
import { SYSTEM_ADMINISTRATOR } from "../../../utils/constants";

export function* handleUserLogin(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(userLogin, action.payload);
    const { data } = response;
    yield put(setLoaderState(false));
    if (data?.item?.userToken) {
      yield put(setSentOtpSuccessFul("success"));
      sessionStorage.setItem("tempToken", data?.item?.userToken);
    } else {
      yield put(setSentOtpSuccessFul("fail"));
    }
  } catch (error) {
    yield put(setLoaderState(false));
    if (error.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}

export function* handleMainUserLogin(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(userMainLogin, action.payload);
    const { data } = response;
    yield put(setLoaderState(false));
    sessionStorage.setItem("loginToken", data.item.token);
    const roleData = data.item.role.filter((x) => {
      return x.isAdmin === true;
    });
    const role = roleData.length ? roleData[0].roleName : data.item.role[0].roleName; // we've to move this logic to somewhere else
    if(role !== SYSTEM_ADMINISTRATOR)
          yield put(setCurrentClient(data.item.clientId));
    yield put(setTnCAccepted(data.item.isTermsAndConditionsAccepted));
    yield put(setUserRole(role));
    yield put(setUserAuthentication(true));
    yield put(setUserLogin(data.item));
    yield put(setOtpExpired(false));
  } catch (error) {
    yield put(setOtpExpired(true));
    yield put(setLoaderState(false));
    if (error.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}

export function* handleResendOtp(action) {
  try {
    yield put(setLoaderState(true));
    yield put(setOtpExpired(false));
    const response = yield call(userResendOtp, action.payload);
    yield put(setLoaderState(false));
    sessionStorage.setItem("tempToken", response?.data?.item.userToken);
  } catch (error) {
    yield put(setLoaderState(false));
    yield put(setOtpExpired(true));
    if (error.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}

export function* handleConfirmEmail(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(confirmEmail, action.payload);
    const { data } = response;
    yield put(setConfirmEmail(data.succeeded));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield put(setConfirmEmail(error.response.data.succeeded));
    if (error.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}

export function* handleVerificationCode(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(verificationCode, action.payload);
    yield put(setLoaderState(false));
    yield put(setVerificationCode(true));
  } catch (error) {
    yield put(setLoaderState(false));
    yield put(setVerificationCode(error.response.data.succeeded));
    if (error.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}

export function* handleUserPassword(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(userPassword, action.payload);
    yield put(setLoaderState(false));
    yield put(setUserPassword(true));
  } catch (error) {
    yield put(setUserPassword(error.response.data.succeeded));
    yield put(setLoaderState(false));
    if (error.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}
